import CustomerInfo from './CustomerInfo'
import CustomerInfoContainer from './CustomerInfoContainer'

export default CustomerInfoContainer(CustomerInfo)
